import { createFileRoute, useParams } from '@tanstack/react-router';
import { ClientPortalPage } from '@/features/foodcost/PortaleClientePage';

export const Route = createFileRoute('/_app/foodcost/portale/$clienteId')({ component: Portal });

function Portal() {
  const { clienteId } = useParams({ from: '/_app/foodcost/portale/$clienteId' });
  return <ClientPortalPage clienteId={clienteId} />;
}
